export default __webpack_public_path__ + "static/media/featured-artist-artwork-2.fec32cd8.png";